var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.schedulerConfig)?_c('bryntum-scheduler',_vm._b({},'bryntum-scheduler',_vm.schedulerConfig,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }